import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { graphql } from "gatsby";
import { GatsbyImage as Image, getImage } from "gatsby-plugin-image";

export default function SlideWithSchematic({ data }) {
  const { backgroundImage, slideContent, title } = data;

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    dotsClass: "slick-dots schematic-indicator",
  };

  return (
    <section className="w-full hds-container pt-20 pb-32">
      <div
        className={`${
          !backgroundImage && "bg-gray-300"
        } w-full absolute right-0 inset-y-0 overflow-hidden`}
      >
        {backgroundImage && (
          <Image
            className="w-full h-full object-cover object-center"
            image={getImage(backgroundImage)}
            alt={backgroundImage.alt ? backgroundImage.alt : ""}
          />
        )}
      </div>

      <h4 className="font-heading font-bold text-xl md:text-5xl text-white relative z-20 mb-10 text-center">
        {title}
      </h4>

      <Slider
        className="text-white"
        {...settings}
        customPaging={() => {
          return <div className="w-12 h-2" />;
        }}
      >
        {slideContent.map((c) => (
          <div key={c.id}>
            <div className="flex flex-col items-center justify-center md:grid md:grid-cols-6 md:gap-6">
              <div className="col-start-3 font-body flex flex-col items-center justify-center">
                <h5 className="font-bold pb-6 text-2xl">{c.schematicTitle}</h5>
                <p className="text-center text-lg pb-6">
                  {c.schematicDescription}
                </p>
              </div>
              <div className="col-start-4">
                <img
                  src={c.image.url}
                  alt={c.image.alt}
                  className=""
                  style={{ maxWidth: "200px", maxHeight: "400px" }}
                />
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </section>
  );
}

export const query = graphql`
  fragment SlideWithSchematic on DatoCmsSlideWithSchematic {
    internal {
      type
    }
    id
    backgroundImage {
      alt
      gatsbyImageData
    }
    title
    slideContent {
      id
      image {
        alt
        url
      }
      schematicTitle
      schematicDescription
    }
  }
`;
